<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style lang="scss">
.input-wdt {
  width: 100%;
}
.level-inner-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.level-inner-wrap .select-level-drop {
  width: 70%;
  margin-right: 15px;
}
.create-category {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.create-category .input-wdt2 {
  width: 80%;
  margin-right: 15px;
}
.con-img-upload {
  background: #efebeb;
}
.ql-container.ql-snow {
  min-height: 150px;
}
.profile-edit .ql-editor {
  min-height: 150px;
}
.countDivder {
  margin: 30px 0 0;
}
.rqrd {
  color: #f00;
}

.profile-edit{display:flex;}
.profile-edit .unlayer-editor{width: 100%}
</style>
<template>
  <div id="page-edit-tab-account">
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/3 w-full mt-2">
        <label>
          Page Title
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="inputx w-full"
          name="Page Title"
          v-model="data_local.Title"
          @blur="setSlug"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Page Title')"
        >{{ errors.first('Page Title') }}</span>
      </div>
      <div class="vx-col md:w-1/3 w-full mt-2">
        <label>
          Slug
        </label>
        <vs-input
          class="inputx w-full"
          readonly
          disabled
          v-model="data_local.Slug"
        />
        <span
          class="text-danger text-sm"
          v-show="SlugErrorMsg"
        >{{ SlugErrorMsg }}</span>
      </div>
      <div class="vx-col md:w-1/3 w-full mt-2">
        <label>Published</label>
        <vs-switch v-model="data_local.IsPublished">
          <span slot="true">True</span>
          <span slot="false">False</span>
        </vs-switch>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-2">
        <label>
          Meta Title
        </label>
        <vs-input
          class="inputx w-full"
          v-model="data_local.MetaTitle"
        />
      </div>
      <div class="vx-col md:w-1/2 w-full mt-2">
        <label>
          Meta Description
        </label>
        <vs-textarea 
          class="inputx w-full"
          v-model="data_local.MetaDescription"
        />
      </div>
      
      <!-- <div class="vx-col md:w-1/1 w-full mt-5">
        <label>Content</label>
        <div class="profile-edit">
          <EmailEditor ref="emailEditor" v-on:load="editorLoaded" v-bind:projectId="projectId" v-bind:templateId="templateId" v-bind:style="{ minHeight: minHeight }" />
        </div>
      </div> -->
      

    </div>

    <div class="vx-row">
      <div class="vx-col md:w-1/1 w-full mt-5">
        <div class="mail-tmplt-btns">
          <label>Content</label>
          <div class="tmplt-btn-wrapp">
            <a
              class="right-off-radius"
              :class="showRawJson ? 'bg-grey': ''"
              @click="showRawJson = showRawJson ? false : true"
              >{{ showRawJson ? "Hide Json" : "Show Json" }}</a
            >
            <a
              class="right-off-radius"
              :class="showRawHtml ? 'bg-grey': ''"
              @click="showRawHtml = showRawHtml ? false : true"
              >{{ showRawHtml ? "Hide Html" : "Show Html" }}</a
            >
            <a
              class="right-off-radius"
              :class="showEditor ? 'bg-grey': ''"
              @click="showEditor = showEditor ? false : true"
              >{{ showEditor ? "Hide Editor" : "Show Editor" }}</a
            >
            <a
              class="off-after"
              :class="showPreviewHtml ? 'bg-dark': ''"
              @click="showPreviewHtml = showPreviewHtml ? false : true"
              >{{ showPreviewHtml ? "Hide Preview" : "Show Preview" }}</a
            >
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/1 w-full">
        <div class="profile-edit">
          <EmailEditor
            ref="emailEditor"
            v-on:load="editorLoaded"
            v-bind:projectId="projectId"
            v-bind:templateId="templateId"
            v-bind:style="{ minHeight: minHeight }"
            v-if="!showRawHtml && !showPreviewHtml && !showRawJson && !showEditor"
          />
          <vs-textarea
            v-if="showRawHtml && !showPreviewHtml && !showRawJson && !showEditor"
            class="inputx w-full"
            v-model="data_local.html"
            rows="10"
            cols="100"
          />
          <vs-textarea
            v-if="showRawJson && !showRawHtml && !showPreviewHtml && !showEditor"
            class="inputx w-full"
            v-model="data_local.designJson"
            rows="100"
          />
          <ckeditor class="inputx w-full" v-if="showEditor && !showRawJson && !showRawHtml && !showPreviewHtml" v-model="data_local.html" :config="editorConfig"></ckeditor>          
          <div v-if="showPreviewHtml" v-html="data_local.html"></div>
        </div>
      </div>
    </div>
    

    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class=" mt-2" @click="$router.push('/event/custompages')">Back To List</vs-button>
        <!-- <vs-button class="ml-4 mt-2" type="border" color="dark" @click="exportHtml">Export HTML</vs-button> -->
          <vs-button
            class="ml-auto mt-2"
            @click="before_save"
            :disabled="!validateForm"
          >Save Changes</vs-button>
          <!-- <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button> -->
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import vSelect from "vue-select";
import { EmailEditor } from 'vue-email-editor'
import CKEditor from 'ckeditor4-vue';
import CKconfig from "@/assets/ckeditor-config.ts";
import ls from "@/common/localStorage"

var Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id")

export default {
  components: {
    vSelect,
    EmailEditor,
    ckeditor: CKEditor.component
  },
  props: {
    data: {
      type: Object,
      required: true,
    }
  },
  watch:{
    
  },
  data() {
    return {
      editorConfig: CKconfig.editorConfig,
      CategoryName: "",
      CategoryColor: "",
      LogoSize: "1X",
      CategoryList: [],
      popupCategoryActive: false,
      data_local: JSON.parse(JSON.stringify(this.data)),
      projectId: this.data.UnlayerLandingPage.ProjectId,
      templateId: this.data.UnlayerLandingPage.TemplateId,
      minHeight: '500px',
      showRawHtml: false,
      showPreviewHtml: this.$route.params.pageId ? true : false,
      showRawJson: false,
      showEditor: false,
      SlugErrorMsg: null
    };
  },
  computed: {
    status_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.status),
          value: this.data_local.status,
        };
      },
      set(obj) {
        this.data_local.status = obj.value;
      },
    },
    role_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.role),
          value: this.data_local.role,
        };
      },
      set(obj) {
        this.data_local.role = obj.value;
      },
    },
    validateForm() {
      return !this.errors.any();
    },    
  },
  methods: {
    setSlug(){      
      if(this.data_local.Title && !this.$route.params.pageId){ 
        this.data_local.Slug = null;
        this.SlugErrorMsg = null;       
        let slug = `${this.data_local.Title.replace(/\s+/g, '').replace(/[^\w\s]/gi, '').toLowerCase()}`;
        let found = this.$store.state.pageManagement.pages.some(el=> el.Slug == slug)
        if(!found) 
          this.data_local.Slug = slug;
        else
          this.SlugErrorMsg = "Please use another page title!";
      }
    },
    editorLoaded() {
      let designJson = JSON.parse(this.data_local.designJson)
        this.$refs.emailEditor.editor.loadDesign(designJson);
      },
      saveDesign() {
        this.$refs.emailEditor.editor.saveDesign(
          (design) => {
            console.log('saveDesign', design);
          }
        )
      },
      exportHtml() {
        this.$refs.emailEditor.editor.exportHtml((data) => {
            //console.log('exportHtml', data);
            let filename = this.data_local.Title ? this.data_local.Title.replace(/\s+/g, '-').toLowerCase() : 'custompage'
            filename += "-" + this.data_local.randomNumber
            var elHtml = data.html
            var link = document.createElement('a');
            let mimeType = 'text/html';

            link.setAttribute('download', filename+".html");
            link.setAttribute('href', 'data:' + mimeType  +  ';charset=utf-8,' + encodeURIComponent(elHtml));
            link.click(); 
        })
      },
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes();
        }
      });
    },
    processJson(){
      return new Promise(async(resolve, reject) => {
        this.$refs.emailEditor.editor.exportHtml(await function(data){
          resolve(data)
        });
      });
    },
    async save_changes() {
      /* eslint-disable */
      if (!this.validateForm || this.SlugErrorMsg) return;

      this.$vs.loading();
      if(!this.showRawHtml && !this.showPreviewHtml && !this.showRawJson && !this.showEditor){
        let data = await this.processJson();        
        this.data_local.html = data.html
        this.data_local.designJson = JSON.stringify(data.design)             
      }else{
        //this.data_local.designJson = JSON.parse(JSON.stringify(this.data_local.html));
      }
      const Id = this.$route.params.pageId;      
      if (Id) {
          this.$store
            .dispatch("pageManagement/updatePage", {
              id: Id,
              data: this.data_local,
            })
            .then((res) => {
              //alert(res.message)
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Page",
                text: "Page updated successfully.",
              });
              this.$vs.loading.close();
              //this.$router.push("/event/custompages/");
            })
      } else {
          this.$store
            .dispatch("pageManagement/addPage", { data: this.data_local })
            .then((res) => {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Page",
                text: "Page created successfully.",
              });
              this.$vs.loading.close();
              if (res.status == 200) {
                this.$router.push("/event/custompages/");
              }
            })
      }
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
      this.imgSrc = this.data.Logo;
    },
    
  },
  created() {
  },
};
</script>
